import {
  Wrapper
} from './styles'

interface props {
  children: React.ReactElement;
}

export default function Container({ children }: props) {
  return (
    <Wrapper>
      {children}
    </Wrapper>
  )
}